/**
 * The lines a VoiceAgent pass adds to a transcript (plan-021 WAPP-HIST, design §33.13.3): the divider where the next
 * VoiceAgent took over — "Passed to Delivery · With a summary", "Passed from Customer support", "Back with Customer
 * support" — with "What Delivery was told" under it when the reader reads transcripts, a refused pass ("Could not pass to
 * Delivery: it was outside its opening hours") and a stint's outcome ("Outcome with Delivery: Order placed").
 *
 * History's transcript and the test console's draw the same lines from `voiceAgentPassTranscriptOf` /
 * `voiceAgentPassLiveTranscriptOf` (`api/voice-agent-stint-view.ts`); a conversation one VoiceAgent answered never
 * reaches this component.
 */
import type { ReactNode } from "react";

import type { VoiceAgentPassTranscriptEntry } from "../../api/voice-agent-stint-view.js";

import "./voice-agent-pass-line.css";

export function VoiceAgentPassLine({
  entry,
}: {
  readonly entry: Exclude<VoiceAgentPassTranscriptEntry<unknown>, { readonly kind: "item" }>;
}): ReactNode {
  switch (entry.kind) {
    case "divider":
      return (
        <>
          <p className="vap-divider">
            <span>{entry.divider.text}</span>
            {entry.divider.modeText === null ? null : <span className="vap-divider-mode">{entry.divider.modeText}</span>}
          </p>
          {entry.divider.summary === null ? null : (
            <p className="vap-summary">
              <span className="vap-summary-label">{entry.divider.summary.label}</span>
              <span>{entry.divider.summary.text}</span>
            </p>
          )}
        </>
      );
    case "refused":
    case "outcome":
      return <p className="vap-line-note">{entry.text}</p>;
  }
}
